module.exports = __webpack_public_path__ + "media/theme/icons-1f568afd.svg";